import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const generatePointageMaterielPDF = ({
  date,
  userName,
  chantiersLabel,
  rows
}) => {
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  // 🧾 En-tête
  doc.setFontSize(16);
  doc.text('Pointage Matériel – Journalier', 14, 15);

  doc.setFontSize(10);
  doc.text(`Date : ${date || ''}`, 14, 22);
  doc.text(`Utilisateur : ${userName || ''}`, 14, 27);
  doc.text(`Chantiers : ${chantiersLabel || 'Tous'}`, 14, 32);

  // 🧮 Sécurité : si aucune ligne
  if (!rows || !rows.length) {
    doc.text('Aucun pointage matériel à imprimer.', 14, 45);
    doc.save(`pointage_materiel_${date}.pdf`);
    return;
  }

  // 📊 Table
  autoTable(doc, {
    startY: 38,
    head: [[
      'ID',
      'Matricule',
      'Type',
      'Chantier',
      'Compteur P',
      'Compteur N',
      'Heures',
      'Gasoil',
      'Essence',
      'Graisse',
      'Vidange',
      'Qté',
      'Réparation',
      'Observation'
    ]],
    body: rows.map(r => ([
      r.id_materiel ?? '',
      r.matricule ?? '',
      r.type ?? '',
      r.chantier_actuel ?? '',
      r.compteur_prec ?? '',
      r.compteur_nv ?? '',
      r.heures_reels ?? '',
      r.gasoil ?? '',
      r.essence ?? '',
      r.graisse ?? '',
      r.vidange ?? '',
      r.qte ?? '',
      r.reparation ?? '',
      r.observation ?? ''
    ])),
    styles: {
      fontSize: 8,
      cellPadding: 2
    },
    headStyles: {
      fillColor: [109, 78, 54] // marron ShemsPaie
    }
  });

  // 💾 Save
  doc.save(`pointage_materiel_${date}.pdf`);
};
